export default {"src":"/_next/static/media/WhoWeAre_040A.4f26e0e1.JPG","height":690,"width":1920};